import React from 'react';

// enter key events were being sent to the first registered event handler, which would be the parent window in nested popup windows
// instead they need to go FIFO through the callbacks, so this is a middleware object to get callbacks for an event and call them
// in reverse letting each call determine if it should continue or not
const popupWindowKeypressEventHandlerManager = new class {
		constructor() {
			// the callbacks for when a key is pressed, insert to the front of this array
			this.callbacks = [];
		}

		keyPressed = e => {
			let result;
			switch (e.keyCode) {
				case 27:
				case 13:
					// go through callbacks (concat to clone so if something gets removed it doesn't get weird)
					result = this.callbacks.concat([])
						// check if any callbacks want to stop propagation
						.reduce((allowNext, callback) => allowNext && callback.callback(e), true);

					if (!result) {
						e.stopPropagation();
						e.preventDefault();
					}
					break;

				default:
					// let key continue
					result = true;
					break;
			}
			return result;
		};

		// start listening for enter/cancel keys
		addEventCallback = (listener, callbackFunc) => {
			// check if this is the first event to be registered
			if (!this.callbacks.length) {
				document.addEventListener("keydown", this.keyPressed);
			}

			// add callback to front so that newest registered get first crack at events (ie when a popup pops on another popup the second popup should get first crack at events)
			this.callbacks.unshift({listener: listener, callback: callbackFunc});
		};

		// stop listening for enter/cancel keys
		removeEventCallback = listener => {
			this.callbacks.splice(this.callbacks.findIndex(callback => callback.listener === listener), 1);

			// not listening anymore so remove listener
			if (!this.callbacks.length) {
				document.removeEventListener('keydown', this.keyPressed);
			}
		};
	}
;

export default popupWindowKeypressEventHandlerManager;